import { global } from "../../constants";

export const data = {
  banner: {
    base: "Servicios",
    background: global.banner + "sts_services.webp",
    title: "Operaciones STS",
    crumb: "Operaciones STS",
  },
  icon: "fa-solid fa-exchange-alt",
  shortDescription:
    "Servicios integrales para operaciones Ship-to-Ship (STS): planificación, permisos, supervisión técnica y gestión de riesgos para transferencias seguras y cumplidoras de normativa.",
  title: "Operaciones STS",
  features: {
    title: "Operaciones STS",
    deliverables: "Entregables",
    reqDocuments: "Documentos Requeridos",
    subtitle:
      "Planificación, ejecución y supervisión técnica de operaciones Ship-to-Ship (transferencia entre buques) con cumplimiento marpoliano, guías OCIMF/ISGOTT y normativa local.",
    description: `Ofrecemos servicios integrales para STS que cubren la evaluación previa de buques, elaboración y validación del Plan STS, coordinación de equipos especializados (STS Master/Loading Master), verificación de equipamiento y sistemas de transferencia, gestión de permisos y comunicaciones con autoridades portuarias y de bandera, y soporte en gestión de siniestros y reclamaciones. Nuestro enfoque combina cumplimiento regulatorio, mejores prácticas OCIMF/ISGOTT y controles de compliance para mitigar riesgos operativos, ambientales y legales.`,
    viewDetail: "Ver Detalles",
    feats: [
      {
        key: "plan_sts",
        title: "Elaboración y validación del Plan de Operaciones STS (MARPOL/OCIMF)",
        summary:
          "Redacción del Plan STS conforme a MARPOL (Anexo I) y guías OCIMF/ISGOTT, con aprobación y firmas requeridas por la autoridad del pabellón/cliente.",
        details:
          "Preparamos el Plan STS que incluye descripción de la maniobra, límites operativos, equipos y mangueras homologadas, procedimiento para arribo y desatraque, responsabilidades (Masters, Loading Master), comunicaciones y checklist obligatorio pre-transfer. Gestionamos la aprobación ante la autoridad de bandera o entidad competente cuando corresponde.",
        deliverables: [
          "Plan STS completo y versión para firma",
          "Checklists pre-transfer y durante la operación",
          "Registro de aprobaciones y comunicaciones"
        ],
        requiredDocs: [
          "Formato de Plan STS previo o plantilla del operador",
          "Datos de contacto de responsables y autoridades",
          "Especificaciones técnicas de mangueras y equipo"
        ],
        icon: "fa-solid fa-file-lines",
        image: global.services + "operations_sts/1.webp",
      },
      {
        key: "evaluacion_previa",
        title: "Evaluación previa y due diligence operacional",
        summary:
          "Verificación técnica y legal de buques, tripulación, propietarios, y manifiestos antes de autorizar la operación STS.",
        details:
          "Realizamos chequeos KYC y due diligence técnico: compatibilidad de casco y tanques, registro de banderas, certificados de seguridad, historial de siniestros, antecedentes de sanciones, y verificación de aseguradoras. Esto incluye comunicación con consignatarios, armadores y proveedores de equipo STS.",
        deliverables: [
          "Informe de due diligence (legal y técnico)",
          "Lista de compatibilidad y riesgos detectados",
          "Recomendación de acciones mitigantes"
        ],
        requiredDocs: [
          "Certificados de clasificación y seguridad del buque",
          "Registro del buque y documentación de propiedad",
          "Historial de reclamaciones/siniestros y pólizas de seguro"
        ],
        icon: "fa-solid fa-search",
        image: global.services + "operations_sts/2.webp",
      },
      {
        key: "supervision_tecnica",
        title: "Supervisión técnica y personal especializado (STS Master / Loading Master)",
        summary:
          "Suministro y coordinación de supervisores STS (Masters/Loading Masters) y técnicos para dirigir y vigilar la operación.",
        details:
          "Proveemos o coordinamos técnicos y supervisores certificados que dirigen la maniobra, controlan comunicaciones, verifican conexiones y autorizarán inicio/parada de bombeo. Se elaboran roles y puntos de contacto (comando unificado) para la operación.",
        deliverables: [
          "Asignación de STS Master / Loading Master",
          "Hoja de roles y responsabilidades",
          "Informe operativo post-transfer"
        ],
        requiredDocs: [
          "CV y certificaciones del personal técnico",
          "Autorizaciones de embarque y permisos",
          "Programación de la operación y ventanas horarias"
        ],
        icon: "fa-solid fa-user-astronaut",
        image: global.services + "operations_sts/3.webp",
      },
      {
        key: "equipamiento_y_mooring",
        title: "Equipamiento, fenders y maniobra de amarre (mooring)",
        summary:
          "Verificación y suministro de sistemas de amarre, fenders y equipos de seguridad/mangueras aprobadas para la transferencia.",
        details:
          "Validamos especificaciones de fenders, longitudes de amarre, fuerzas de línea, capacidad de winches, protección de casco y compatibilidad de mangueras con la carga. Coordinamos proveedor de fenders y sistema de bombeo con pruebas de integridad antes de la maniobra.",
        deliverables: [
          "Checklist de equipos y fenders",
          "Informe de compatibilidad mangueras y conexiones",
          "Plan de amarre con fuerzas calculadas"
        ],
        requiredDocs: [
          "Especificaciones técnicas de mangueras y fenders",
          "Datos de carga (densidad, temperatura)",
          "Registro de mantenimiento de equipos"
        ],
        icon: "fa-solid fa-anchor",
        image: global.services + "operations_sts/4.webp",
      },
      {
        key: "seguridad_medida_contaminacion",
        title: "HSE, respuesta a derrames y contingencias ambientales",
        summary:
          "Planificación HSE, medidas preventivas y coordinación del Plan de Contingencia ante derrames (OSCP) durante la operación STS.",
        details:
          "Diseñamos controles HSE específicos: vigilancia de atmósferas, control de fuentes de ignición, comunicación de emergencia, plan de segregación de espacios y coordinación con OSCP/autoridades en caso de derrame. Incluye disponibilidad de equipos de contención y booms si aplica.",
        deliverables: [
          "Plan HSE y de contingencia específico para la operación",
          "Lista de equipos de contención y contactos de respuesta",
          "Reporte post-operación con observaciones de seguridad"
        ],
        requiredDocs: [
          "Plan de contingencia/OSCP vigente",
          "Certificados de instrumentación gas y calibración",
          "Procedimientos de seguridad del buque"
        ],
        icon: "fa-solid fa-shield-halved",
        image: global.services + "operations_sts/5.webp",
      },
      {
        key: "compliance_y_permisos",
        title: "Permisos, notificaciones y cumplimiento local (incluye requisitos en aguas venezolanas)",
        summary:
          "Gestión de permisos portuarios, notificaciones a autoridades competentes y cumplimiento de requisitos locales (p. ej. INEA en Venezuela).",
        details:
          "Tramitamos autorizaciones ante autoridades portuarias y marinas, presentamos notificaciones reglamentarias (Autoridad de Espacios Acuáticos o similares), coordinamos vías de acceso y zonas autorizadas, y verificamos requerimientos de seguro y fianzas exigidas por el regulador local.",
        deliverables: [
          "Trámite y obtención de permisos/notificaciones",
          "Registro de comunicación con autoridades",
          "Listado de requisitos locales cumplidos"
        ],
        requiredDocs: [
          "Solicitud/plan de operación enviada a autoridad",
          "Documentación del buque y manifiesto de carga",
          "Pólizas de seguro y garantías requeridas"
        ],
        icon: "fa-solid fa-landmark",
        image: global.services + "operations_sts/6.webp",
      },
      {
        key: "documentacion_entrega",
        title: "Documentación, certificaciones y cierre administrativo",
        summary:
          "Generación de certificados de transferencia, notas de entrega de carga y registro de tiempos/volúmenes para efectos legales y comerciales.",
        details:
          "Emitimos registros de transferencia (quantitative transfer statement), control de volúmenes y temperaturas, certificados de recibo/entrega de carga, y documentación contable para facturación y claims. Se mantiene un dossier operativo para auditorías posteriores.",
        deliverables: [
          "Acta y registro de transferencia (QTY statement)",
          "Informe de volúmenes y parámetros de transferencia",
          "Dossier operativo y registro de firmas"
        ],
        requiredDocs: [
          "Manifiestos y Bill of Lading / documentación de carga",
          "Registro de mediciones y certificados de laboratorio (si aplica)",
          "Firmas autorizadas de ambas partes"
        ],
        icon: "fa-solid fa-file-contract",
        image: global.services + "operations_sts/7.webp",
      },
      {
        key: "seguros_y_reclamaciones",
        title: "Seguros, responsabilidad civil y gestión de reclamaciones",
        summary:
          "Asesoría en colocación de coberturas específicas para STS y gestión de siniestros/reclamaciones posteriores a una transferencia.",
        details:
          "Revisamos pólizas H&M, P&I y cargo para identificar brechas en cobertura durante STS, asesoramos en extensión de coberturas o endosos temporales, y gestionamos la interacción con ajustadores en caso de pérdidas, derrames o daños a terceros.",
        deliverables: [
          "Análisis de cobertura e informe de gaps",
          "Recomendación de endosos o pólizas temporales",
          "Asistencia en gestión de reclamos y coordinación con aseguradoras"
        ],
        requiredDocs: [
          "Pólizas vigentes (H&M, P&I, Cargo)",
          "Reportes de incidentes y peritajes",
          "Comunicación oficial entre partes"
        ],
        icon: "fa-solid fa-hand-holding-dollar",
        image: global.services + "operations_sts/8.webp",
      }
    ],
  },
  ctaText: "Solicitar operación STS o cotización",
  ctaLink: "/contacto?servicio=operaciones-sts",
};
